import(/* webpackMode: "eager" */ "/vercel/path0/src/app/test/page.tsx");
